import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { HomeLogoComponent } from './home-logo/home-logo.component';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { NavLinksComponent } from './nav-links/nav-links.component';
import { LangSelectionComponent } from './lang-selection/lang-selection.component';
import { IconButtonComponent } from '@shared/ui-components/icon-button/icon-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsTriggerComponent } from '@core/components/header/notifications-trigger/notifications-trigger.component';
import { ProfileTriggerComponent } from '@core/components/header/profile-trigger/profile-trigger.component';
import { HelpTriggerComponent } from './help-trigger/help-trigger.component';
import { featureFlags } from '@shared/constants/feature-flags';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';

@Component({
  selector: 'ac-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    HomeLogoComponent,
    IconComponent,
    NavLinksComponent,
    LangSelectionComponent,
    IconButtonComponent,
    NotificationsTriggerComponent,
    TranslateModule,
    ProfileTriggerComponent,
    HelpTriggerComponent,
  ],
})
export class HeaderComponent {
  @Output() menuTrigger = new EventEmitter<void>();
  protected readonly _shouldRenderLangSelection: boolean = featureFlags.translationFeatureFlag;
  protected readonly _authUserSig = inject(Store<StoreState>).selectSignal(userSelectors.authUser);
}
